import React from 'react';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import OnScrollBottom, {
  DISTANCE_UNIT,
} from '@wix/da-shared-react/pkg/OnScrollBottom';
import FoldersHeader from '../FoldersHeader';
import FolderSlider from '../FolderSlider';
import FolderContentList from '../FolderContentList';

import s from './GallectionsListView.scss';

export interface Props {
  distanceToBottom: number;
  onScrollToFolder: (folderId: number) => void;
  onScrolledToBottom: () => void;
}

const DesktopGallectionsListView: React.FC<Props> = ({
  onScrollToFolder,
  distanceToBottom,
  onScrolledToBottom,
}) => {
  return (
    <div className={s['root']}>
      <ErrorBoundary>
        <FoldersHeader />
        <FolderSlider />
        <div id="sub-folder-gallery">
          <FolderContentList onScrollToFolder={onScrollToFolder} />
          <OnScrollBottom
            distanceToBottom={distanceToBottom}
            distanceUnit={DISTANCE_UNIT.WINDOW_HEIGHT}
            onScrolledToBottom={onScrolledToBottom}
          />
        </div>
      </ErrorBoundary>
    </div>
  );
};
DesktopGallectionsListView.displayName = 'DesktopGallectionsListView';

export default DesktopGallectionsListView;
